module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 14.182b5be1.mp3";